<template>
<div
  class="input-group"
  v-if="loaded"
>
  <div
    class="input-group-prepend"
  >
    <div
      class="input-group-text"
    >
      <ItpIcon
        icon="ic:baseline-cable"
      >
      </ItpIcon>
    </div>
  </div>
  <ItpFormSelect2
    name="source"
    v-model="item.source"
    bind-object
    :options="sources"
    valueField="value"
    textField="name"
    clearable
    :readonly="readonly"
    @input="evh_5962862420439144_input($event, {})"
  >
  </ItpFormSelect2>
  <ItpFormSelect
    name="rate_source"
    v-model="item.rate_source"
    :options="rateSources"
    valueField="value"
    textField="name"
    clearable
    null-option
    :readonly="readonly"
    @input="evh_8358196963355853_input($event, {})"
  >
  </ItpFormSelect>
  <ItpFormInput
    name="invoice_description"
    v-model="item.invoice_description"
    :readonly="readonly"
    :placeholder="'Invoice description'|pgettext('ExchangeRateSourceSpec')"
    @input="evh_1048678296148443_input($event, {})"
  >
  </ItpFormInput>
</div>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class ExchangeRateSourceSpecEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  emitChange(...args: any[]) {
    let value = this.item;
    if (_.isEmpty(value.source) || _.isEmpty(value.rate_source)) { value = null; }
    this.$emit('input', value);
  }

  @Prop({
    type: Object,
  })
  value!: object;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  item!: any;

  async $$load_item() {
    return this.value || {
      source: null,
      rate_source: null,
      invoice_description: null,
    }
  }

  sources!: any;

  async $$load_sources() {
    return this.$app.repo.get('list_exchange_rate_source')
  }

  rateSources!: any;

  async $$load_rateSources() {
    return this.$app.repo.get('ui_metadata', { path: 'exchange_rate_rate_source_type_options' })
  }

  ux!: any;
  dataMembers = ['item', 'sources', 'rateSources', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        sources: null,
        rateSources: null,
        ux: null,
      },
    }
  }

  async act_5962862420439144_script_6660_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5962862420439144_script_6660, alias=emitChange
    this.emitChange()
  }

  async act_5962862420439144_script_6660_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5962862420439144_script_6660, alias=emitChange
    return {
      value: () => this.act_5962862420439144_script_6660_getActionArgs_value($event),
    }
  }

  async evh_5962862420439144_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_input.executeFromDOM(this, event, scope);
  }

  async act_8358196963355853_script_6662_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_8358196963355853_script_6662, alias=emitChange
    this.emitChange()
  }

  async act_8358196963355853_script_6662_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_8358196963355853_script_6662, alias=emitChange
    return {
      value: () => this.act_8358196963355853_script_6662_getActionArgs_value($event),
    }
  }

  async evh_8358196963355853_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8358196963355853_input.executeFromDOM(this, event, scope);
  }

  async act_1048678296148443_script_6664_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1048678296148443_script_6664, alias=emitChange
    this.emitChange()
  }

  async act_1048678296148443_script_6664_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1048678296148443_script_6664, alias=emitChange
    return {
      value: () => this.act_1048678296148443_script_6664_getActionArgs_value($event),
    }
  }

  async evh_1048678296148443_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1048678296148443_input.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_5962862420439144_script_6660: actions.ScriptAction;
    evh_5962862420439144_input_6659: actions.EventHandlerImpl;
    evh_5962862420439144_input: actions.EventHandlerGroup;
    act_8358196963355853_script_6662: actions.ScriptAction;
    evh_8358196963355853_input_6661: actions.EventHandlerImpl;
    evh_8358196963355853_input: actions.EventHandlerGroup;
    act_1048678296148443_script_6664: actions.ScriptAction;
    evh_1048678296148443_input_6663: actions.EventHandlerImpl;
    evh_1048678296148443_input: actions.EventHandlerGroup;
  }

  getActions() {
    const act_5962862420439144_script_6660 = new actions.ScriptAction(
      {
        actionArgs: this.act_5962862420439144_script_6660_getActionArgs,
        displayName: "emitChange",
        events: [],
      }
    );
    const evh_5962862420439144_input_6659 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_script_6660,
        event: "input",
        displayName: "emitChange",
      }
    );
    const evh_5962862420439144_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_input_6659],
      }
    );
    const act_8358196963355853_script_6662 = new actions.ScriptAction(
      {
        actionArgs: this.act_8358196963355853_script_6662_getActionArgs,
        displayName: "emitChange",
        events: [],
      }
    );
    const evh_8358196963355853_input_6661 = new actions.EventHandlerImpl(
      {
        action: act_8358196963355853_script_6662,
        event: "input",
        displayName: "emitChange",
      }
    );
    const evh_8358196963355853_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_8358196963355853_input_6661],
      }
    );
    const act_1048678296148443_script_6664 = new actions.ScriptAction(
      {
        actionArgs: this.act_1048678296148443_script_6664_getActionArgs,
        displayName: "emitChange",
        events: [],
      }
    );
    const evh_1048678296148443_input_6663 = new actions.EventHandlerImpl(
      {
        action: act_1048678296148443_script_6664,
        event: "input",
        displayName: "emitChange",
      }
    );
    const evh_1048678296148443_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_1048678296148443_input_6663],
      }
    );
    return {
      act_5962862420439144_script_6660,
      evh_5962862420439144_input_6659,
      evh_5962862420439144_input,
      act_8358196963355853_script_6662,
      evh_8358196963355853_input_6661,
      evh_8358196963355853_input,
      act_1048678296148443_script_6664,
      evh_1048678296148443_input_6663,
      evh_1048678296148443_input,
      emitChange: act_1048678296148443_script_6664,
    }
  }
}

Vue.component("ExchangeRateSourceSpecEditor", ExchangeRateSourceSpecEditor);

</script>